import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../../lib/utils';
import { getThemeClass } from '../../../lib/theme';
import { cardVariants, withReducedMotion, viewportOptions } from '../../../lib/animations/variants';
import { BaseCardProps } from './types';

export const Card: React.FC<BaseCardProps> = ({
  className,
  variant = 'default',
  theme = 'light',
  size = 'md',
  children,
  animate = false,
}) => {
  const baseStyles = "rounded-lg transition-all duration-300";
  
  const variantStyles = {
    default: "bg-white shadow-sm hover:shadow-md",
    gradient: "bg-white shadow-sm hover:shadow-md overflow-hidden",
    bordered: "border border-slate-200 hover:border-slate-300"
  };
  
  const themeStyles = {
    light: "bg-white",
    dark: "bg-slate-800 text-white"
  };
  
  const sizeStyles = {
    sm: getThemeClass('spacing.container.sm'),  // px-4
    md: getThemeClass('spacing.container.md'),  // px-4 sm:px-6
    lg: getThemeClass('spacing.container.lg')   // px-4 sm:px-6 lg:px-8
  };

  const cardContent = (
    <div
      className={cn(
        baseStyles,
        variantStyles[variant],
        themeStyles[theme],
        sizeStyles[size],
        className
      )}
    >
      {children}
    </div>
  );

  if (animate) {
    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        variants={withReducedMotion(cardVariants)}
      >
        {cardContent}
      </motion.div>
    );
  }

  return cardContent;
};